import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { SIGNOUT } from 'redux/sagas/actions/authentication';
import Button from 'ui/atoms/Button';
import MainFont from 'ui/typography/mainFont';

import { LogoutButton, LogoutText } from './style';

const NoProfile = ({ signOut }) => {
  const { t } = useTranslation();

  return (
    <>
      <MainFont configuration={{ fontSize: 24 }} type="4">
        {t('warning')}
      </MainFont>

      <LogoutText>
        <MainFont configuration={{ fontSize: 16 }}>
          {t('no_profile_text')}
        </MainFont>
      </LogoutText>
      <LogoutButton>
        <Button variant="popupYes" onClick={signOut}>
          {t('logged_me_out')}
        </Button>
      </LogoutButton>
    </>
  );
};

NoProfile.propTypes = {
  signOut: PropTypes.func
};

export default connect(
  () => ({}),
  dispatch => ({
    signOut: () => dispatch({ type: SIGNOUT._REQUEST })
  })
)(NoProfile);
